export default __webpack_public_path__ + "static/4-296eab56d5c1dbb63359793d4d022662.png";